module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-stone-path-background.b7063946.png";